'use client';

import React from 'react';
import styled from 'styled-components';

export interface FormFieldProps {
  label: string;
  htmlFor: string;
  error?: string;
  help?: string;
  required?: boolean;
  children: React.ReactNode;
  className?: string;
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(p) => p.theme.spaceAlias.xs};
`;

const Label = styled.label`
  font-size: ${(p) => p.theme.fontSize.body};
  font-weight: ${(p) => p.theme.fontWeight.semibold};
  color: ${(p) => p.theme.colors.neutral.ink};
  font-family: ${(p) => p.theme.fontFamily.ui};
`;

const Required = styled.span`
  color: ${(p) => p.theme.colors.semantic.error.color};
  margin-inline-start: 2px;
`;

const HelpText = styled.div`
  font-size: ${(p) => p.theme.fontSize.xs};
  color: ${(p) => p.theme.colors.neutral.inkMute};
  font-family: ${(p) => p.theme.fontFamily.ui};
`;

const ErrorText = styled.div`
  font-size: ${(p) => p.theme.fontSize.xs};
  color: ${(p) => p.theme.colors.semantic.error.color};
  font-family: ${(p) => p.theme.fontFamily.ui};
  font-weight: ${(p) => p.theme.fontWeight.medium};
`;

export function FormField({
  label,
  htmlFor,
  error,
  help,
  required,
  children,
  className,
}: FormFieldProps) {
  return (
    <Wrapper className={className}>
      <Label htmlFor={htmlFor}>
        {label}
        {required && <Required aria-hidden="true">*</Required>}
      </Label>
      {children}
      {help && !error && <HelpText id={`${htmlFor}-help`}>{help}</HelpText>}
      {error && (
        <ErrorText id={`${htmlFor}-error`} role="alert">
          {error}
        </ErrorText>
      )}
    </Wrapper>
  );
}
